import { useAppContext } from '../../Services/AppContext';
import FirstUpper from '../FirstUpper';

export default function SearchWorkplaceDoctorNoResults() {
	const { translation } = useAppContext();

	return (
		<div className='search-user-wrapper__no-results'>
			<p className='search-user-wrapper__no-results__text px-3'>
				<FirstUpper>
					{
						translation[
							'component.caseCreate.theDoctorYouWereLookingForWasNotFoundInMEDDI'
						]
					}
				</FirstUpper>
			</p>
		</div>
	);
}
